var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column my-8 rounded-lg"
  }, [_c('v-card', [_c('v-card-text', [_c('v-row', {
    staticClass: "my-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('v-img', {
    staticClass: "flex-shrink-1 mr-4",
    attrs: {
      "contain": "",
      "width": "100%",
      "height": "auto",
      "max-height": "300px",
      "src": "https://media.eipl.org/site/images/services/blood-pressure-reader-trans.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "10"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column flex-grow-1",
    attrs: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticClass: "text-h4 text-sm-h4 primary--text text-wrap-word"
  }, [_vm._v(" Blood Pressure Kits ")]), _c('p', {
    staticStyle: {
      "max-width": "120ch"
    }
  }, [_vm._v(" The library has Blood Pressure Loaner Kits available for East Islip Library cardholders. Each kit contains a blood pressure machine, blood pressure cuff, and a packet of information on blood pressure including a blood pressure log to keep track of your results. East Islip Library cardholders may borrow a kit for up to 28 days; there are no fines, no holds and no renewals. For more information, contact the Reference Desk, 631-581-9200 x5. ")])])], 1)], 1), _c('v-row', {
    staticClass: "my-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "10",
      "order": "2",
      "order-md": "1"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column flex-grow-1",
    attrs: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticClass: "text-h4 text-sm-h4 primary--text text-wrap-word"
  }, [_vm._v(" Homebound Service ")]), _c('p', {
    staticStyle: {
      "max-width": "120ch"
    }
  }, [_vm._v(" Homebound delivery of materials is offered to East Islip Library cardholders on both a short and long term basis. Books and materials will be mailed to you with return postage enclosed. If you cannot get to the library due to an injury, illness or chronic condition, please call the Reference Desk at 631-581-9200 x5 and ask for an application. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "6",
      "md": "3",
      "lg": "2",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('v-img', {
    staticClass: "flex-shrink-1 mr-4",
    attrs: {
      "contain": "",
      "width": "100%",
      "height": "auto",
      "max-height": "300px",
      "src": "https://media.eipl.org/site/images/services/homebound.png"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "my-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "8",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('v-img', {
    staticClass: "flex-shrink-1 mr-4",
    attrs: {
      "contain": "",
      "width": "100%",
      "height": "auto",
      "max-height": "300px",
      "src": "https://media.eipl.org/site/images/services/little-library.png"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "10"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column flex-grow-1",
    attrs: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticClass: "text-h4 text-sm-h4 primary--text text-wrap-word"
  }, [_vm._v(" Little Free Libraries ")]), _c('p', {
    staticStyle: {
      "max-width": "120ch"
    }
  }, [_vm._v(" The library has two Little Free Libraries: at the East Islip Marina and Beaver Dam Park in Islip Terrace. These generously donated beautiful yet durable structures will serve the community for many years. Check them out the next time you are in either area; you will find books for all ages to read while you wait for a game to start, watch your kids on the playground, or lie on the beach. ")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }